import Foundation from 'foundation-sites';
import Swiper, {
	Navigation,
	Pagination,
	Keyboard,
	Scrollbar,
	Lazy,
	HashNavigation,
	Autoplay,
	EffectFade,
	Thumbs,
} from 'swiper';
import Masonry from 'masonry-layout';
import Plyr from 'plyr';
import $ from 'jquery';
window.$ = $;

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Keyboard, Scrollbar, Lazy, Autoplay, EffectFade, Thumbs]);

// Start Foundation
$(document).foundation();

// Init. special page elements
$(document).ready(function ($) {
	// Make external links open new tab
	$(
		'a:not([href^="#"]):not([href*="' +
			window.location.hostname +
			'"]):not([href*="blog.' +
			window.location.hostname.replace(/^(www|blog)\./, '') +
			'"])'
	).attr('target', '_blank');
	$('a[href*="' + window.location.hostname.replace(/^(www|blog)\./, '') + '"]:not(.blank)').attr('target', '');

	// Set Logo URL to home site
	$('header .logo')
		.parent('a')
		.attr('href', 'https://www.' + window.location.hostname.replace(/^(www|blog)\./, ''));

	// Initialize all swipers
	var swiperFacts = new Swiper('.acf-block-swiper-facts .swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 30,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});
	$('.acf-block-swiper-gallery .swiper-container').each(function () {
		new Swiper(this, {
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			spaceBetween: 0,
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
			},
		});
	});

	$('.acf-block-testimonial .swiper-container').each(function () {
		new Swiper(this, {
			loop: true,
			centeredSlides: false,
			spaceBetween: 30,
			pagination: {
				el: $(this).find('.swiper-pagination'),
				clickable: true,
			},
			speed: 1400,
			autoplay: {
				delay: 4000,
				disableOnInteraction: true,
			},
			grabCursor: true,
			draggable: true,
			slidesPerView: 1,
			spaceBetween: 30,
			// init: false,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
			},
		});
	});

	var TentyYearsNewsSwiper = new Swiper('.twenty-years-news-swiper', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 0,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});

	var TentyYearsVIPSwiper = new Swiper('.twenty-years-vip-swiper', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 0,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
		autoplay: false,
	});

	window.vipSwiper = TentyYearsVIPSwiper;

	var TentyYearsRelatedSwiper = new Swiper('.twenty-years-related-articles-swiper', {
		loop: true,
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 15,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	var swiper = new Swiper('.custom-teasers-swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		grabCursor: true,
		draggable: true,
		// init: false,

		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 0,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 0,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 0,
			},
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: true,
		},
	});


	var swiperTemplatePart = new Swiper('.custom-template-part-swiper.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		grabCursor: true,
		draggable: true,
		// init: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		autoplay: {
			delay: 2500,
			disableOnInteraction: true,
		},
		on: {
			init: function () {
				for (const key in Object.keys(this.slides)) {
					if (this.slides[key]) {
						const slide = this.slides[key];
						slide.style.cursor = 'pointer';
						slide.addEventListener('click', (e) => {
							if (!(e.target instanceof HTMLAnchorElement)) {
								e.preventDefault();
								const link = slide.querySelector('.card-section a');
								const uri = link.href;
								const target = link.target == '' ? '_self' : '_blank';
								window.open(uri, target);
							}
						});
					}
				}
			},
		},
	});

	var projectSwiper = new Swiper('.acf-block-swiper-projects .swiper-container', {
		loop: true,
		slidesPerView: 'auto',
		centeredSlides: true,
		spaceBetween: 30,
		grabCursor: true,
		draggable: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		speed: 1400,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
	});

	var homeSwiper = new Swiper('.home-swiper', {
		grabCursor: false,
		draggable: false,
		speed: 1400,
		pagination: {
			el: '.swiper-pagination-home',
			type: 'bullets',
			clickable: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		},
	});

	// Change Logo on scroll
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0) {
			$('.site-header.desktop .logo-container-visibility').fadeOut();
		} else {
			$('.site-header.desktop .logo-container-visibility').fadeIn();
		}
	});

	// Simple go back in history
	function goBack() {
		window.history.back();
	}
});

$(window).on('load', function () {
	window.dispatchEvent(new Event('resize'));
});

/*
 * Make clicking an element trigger a click on the link inside of it (e.g. cards)
 */

document.body.addEventListener('click', function(e) {
  const nestedLinkParentElement = e.target.closest('.clickable');

  if (nestedLinkParentElement && e.target.tagName !== 'A') {
	const nestedLinkElement = nestedLinkParentElement.querySelector('a.permalink');
	const selection = window.getSelection().toString(); // Contains content when user is selecting/highlighting text

	if (!nestedLinkElement || selection) {
	  return;
	}

	e.preventDefault();
	nestedLinkElement.click();
  }
});
